// removed by extract-text-webpack-plugin
module.exports = {"gwSummaryInfoRow":"tile-summary-row-hashed__gwSummaryInfoRow__1VMkZ"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/SummaryRow/tile-summary-row-hashed.scss
// module id = 1225
// module chunks = 0